import { Box, Flex } from '@chakra-ui/react'
import { useRef } from 'react'
import { EncountersPreview } from '../../../../../../charting/Encounters/EncountersPreview'
import { useCreateAssessment } from '../../../../../../hooks/assessments/useCreateAssessment'
import { useResizeObserver } from '../../../../../../hooks/useResizeObserver'
import { SolidActionButton } from '../../../../../Buttons'
import { AddAssessmentAlert } from '../../../Assessments/AddAssessmentAlert'
import { AssessmentsView } from '../../../Assessments/AssessmentSummary'
import { CardsView } from '../Containers/CardsView'
import { PreviewBox } from '../Containers/PreviewBox'

const PregnanciesPreview = () => {
  const { addLoading, confirmingNewAssessment, createAssessment, setConfirmingNewAssessment } =
    useCreateAssessment()
  return (
    <PreviewBox
      header={
        <Flex justify="flex-end" w="100%">
          <AddAssessmentAlert
            isOpen={confirmingNewAssessment}
            onConfirm={createAssessment}
            onCancel={() => setConfirmingNewAssessment(false)}
          />
          <SolidActionButton
            size="xs"
            ml="auto"
            onClick={() => setConfirmingNewAssessment(true)}
            isLoading={addLoading}>
            + New Pregnancy
          </SolidActionButton>
        </Flex>
      }
      title="Pregnancies">
      <Box w="100%">
        <AssessmentsView preview />
      </Box>
    </PreviewBox>
  )
}

export const PatientControlPanel = () => {
  const bodyRef = useRef<HTMLDivElement>(null)
  const { width } = useResizeObserver(bodyRef, 'content')
  return (
    <Flex bg="#dedede" ref={bodyRef} w="100%" h="100%" flexFlow="column">
      <CardsView width={width} elements={[<PregnanciesPreview />, <EncountersPreview />]} />
    </Flex>
  )
}
